import Text from '@src/components/Text';
import dayjs from 'dayjs';

import { CreateFamilyEvent } from '../../type';
import * as S from './styled';

const OpeningPreview = ({
  formData,
  title: _title,
}: {
  formData: CreateFamilyEvent;
  title: string;
}) => {
  const { date, address, detailAddress, contacts, remarks, targetName } = formData;

  console.log(_title);
  const memberStringList = _title
    .replace(`[개업] ${targetName} (`, '')
    .replace(') 사무소 개업 알림!!', '')
    .split(', ');
  const title = memberStringList
    .map(memberString => {
      const [name, licenseCb] = memberString.split('/');
      return `${name}(${licenseCb})`;
    })
    .join(', ');

  return (
    <>
      <Text size={16} weight={500} style={{ marginBottom: 8 }}>
        홈페이지 & 메일
      </Text>
      <S.Container>
        <div
          dangerouslySetInnerHTML={{
            __html: `&nbsp;
<table align="center" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" frame="border" rules="none" width="600" style="font-size: 14px; word-break: break-all; overflow-wrap: break-word; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif;">
    <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
        <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
            <td align="center" valign="top" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 1.5; word-break: break-all; overflow-wrap: break-word; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important;">
            <table align="center" bgcolor="#f0f0f0" cellpadding="0" cellspacing="0" width="600" style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                    <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                        <td width="360" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 1.5; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;"><span style="font-size: 24px; word-break: break-all; overflow-wrap: break-word;"><strong style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">사무소 개업 알림</strong></span></td>
                        <td width="20" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 1.5; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;">&nbsp;</td>
                        <td idth="260" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 1.5; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;"><img alt="" src="https://userimg-mkt.tason.com/20210604/ekcplaa_aa71c92fcccdf73bc88be930abde41cf.png" style="border: 0px solid; font-size: inherit; word-break: break-all; overflow-wrap: break-word; height: 52px; width: 200px;" /></td>
                    </tr>
                </tbody>
            </table>
            <div style="margin: 0px; padding: 0px; font-size: inherit; word-break: break-all; overflow-wrap: break-word; text-align: left;">&nbsp;</div>
            </td>
        </tr>
        <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
            <td align="center" valign="top" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 1.5; word-break: break-all; overflow-wrap: break-word; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important;">
            <div style="margin: 0px; padding: 0px; font-size: inherit; word-break: break-all; overflow-wrap: break-word; text-align: left;">&nbsp;</div>
            <table align="center" cellpadding="0" cellspacing="0" width="540" style="font-size: 12px; word-break: break-all; overflow-wrap: break-word; line-height: 22px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; color: rgb(85, 85, 85);">
                <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                    <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                        <td valign="top" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;">
                          <h2 style="margin: 0px; padding: 0px; font-size: inherit; word-break: break-all; overflow-wrap: break-word;">&nbsp;</h2>
                          <h2 style="margin: 0px; padding: 0px; font-size: 15pt; word-break: break-all; overflow-wrap: break-word; text-align: center; font-family: 휴먼명조;">
                            ${targetName}<br/>
                            ${
                              // memberData
                              // .map(({ name, licenseCb }) => `${name}(${licenseCb})`)
                              // .join(', ')
                              title
                            }<br/>
                            <br/><br/>
                          </h2>
                          <h2 style="margin: 0px; padding: 0px; font-size: 12pt; word-break: break-all; overflow-wrap: break-word; font-family: 휴먼명조;">&nbsp;<br/>
                            <br/>
                            ${
                              remarks
                                ? `<br/>
                            □ 인사의말씀<br/>
                            <br/>
                            ${remarks
                              .split('\n')
                              .map(line => (line ? `${line}` : ''))
                              .join('<br/>')}`
                                : ''
                            }
                            <br/>
                            □ 장소 : ${detailAddress}<br/>
                            ${address}<br/>
                            <br/>
                            □ 일시: ${dayjs(date).format('YYYY. MM. DD')}<br/>
                            <br/>
                            ${
                              contacts.length === 0
                                ? ''
                                : '□ 연락처<br/>' +
                                  contacts
                                    .map(({ name, phone }) => `${name}: ${phone}`)
                                    .join('<br/>')
                            }
                          </h2>
                        </td>
                    </tr>
                </tbody>
            </table>
            </td>
        </tr>
    </tbody>
</table>`,
          }}
        />
      </S.Container>

      <Text size={16} weight={500} style={{ marginTop: 12, marginBottom: 8 }}>
        메시지
      </Text>
      <S.Container style={{ width: '384px' }}>
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {`
${targetName}
${title}
${
  remarks
    ? `\n◎ 인사의 말씀
  ${remarks}`
    : ''
}

◎ 장    소
  ${detailAddress}
  ${address}

◎ 일    시
  ${dayjs(date).locale('ko').format('YYYY년 M월 D일 ')}
${
  contacts && contacts.length
    ? `\n◎ 연 락 처
${contacts
  .map(info => {
    return `  ${info.phone} (${info.name})`;
  })
  .join('\n')}`
    : ''
}
`}
        </div>
      </S.Container>
    </>
  );
};

export default OpeningPreview;
